export default __webpack_public_path__ + "static/media/latest-news-img15.65251b54.jpg";